import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {EquipmentDataFlowService, ModalTypes} from '../services/equipment-data-flow.service';
import {EquipmentCardEnums, EquipmentCardInterfaces} from '@namespaces/equipment.namespace';
import {CalibrationLabelPipe} from '@pipes/calibration-label/calibration-label.pipe';
import {AuthService} from '@services/auth.service';
import {UserNamespace} from '@namespaces/user.namespace';
import {PreviewModalService} from '@services/preview-modal.service';

@Component({
    selector: 'app-equipment-view-tab-calibrations',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './equipment-view-tab-calibrations.component.html'
})

export class EquipmentViewTabCalibrationsComponent implements OnInit {
    @Input() equipment: EquipmentCardInterfaces.Card.ItemView;

    public statuses = EquipmentCardEnums.EquipmentStatus;

    public canAddCalibration = false;

    constructor(
        public calibrationLabelPipe: CalibrationLabelPipe,
        private dataService: EquipmentDataFlowService,
        private authService: AuthService,
        private filesPreviewService: PreviewModalService,
    ) {}

    ngOnInit() {
        this.canAddCalibration = this.authService.hasPermissions([
            UserNamespace.Permission.equipmentCardCalibrationUpdate,
            UserNamespace.Permission.equipmentCardCalibrationAdd
        ]);
    }

    onAddClick() {
        this.dataService.addCalibration$.next();
    }

    showFilesPreview(calibration: EquipmentCardInterfaces.Card.Calibration) {
        if (!calibration.files.length) {
            return;
        }

        const status = this.equipment.apparatus.verification_status;
        const number = calibration.number;
        const message = `
            Свидетельство о ${this.calibrationLabelPipe.transform(status, 'поверке', 'калибровке', 'поверке/калибровке')}
            ${number ? '№ ' + number : ''}
        `;

        this.filesPreviewService.show({
            files: calibration.files,
            title: message,
        });
    }
}
